import { render, staticRenderFns } from "./PopperDemo.vue?vue&type=template&id=67e1b76c&scoped=true&"
import script from "./PopperDemo.vue?vue&type=script&lang=js&"
export * from "./PopperDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1b76c",
  null
  
)

export default component.exports